import { LockClosedIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { LinkButton, StateBlock } from '../components/ui';
import { usePageTitle } from '../hooks/usePageTitle';

const Unauthorized = () => {
    const { t } = useTranslation('auth');
    usePageTitle(t('forbidden.title'));
    return (
        <StateBlock
            variant="empty"
            icon={LockClosedIcon}
            heading="h1"
            title={t('forbidden.title')}
            body={t('forbidden.body')}
            action={
                <LinkButton to="/orders" variant="strong">
                    {t('forbidden.action')}
                </LinkButton>
            }
        />
    );
};

export default Unauthorized;
